var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarket = function SvgMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.477.853 7.438 4.294a2.954 2.954 0 0 1 1.477 2.558v8.59c0 1.055-.563 2.03-1.477 2.558l-7.438 4.294a2.952 2.952 0 0 1-2.954 0l-7.438-4.294a2.954 2.954 0 0 1-1.477-2.558v-8.59c0-1.055.563-2.03 1.477-2.558L10.523.853a2.952 2.952 0 0 1 2.954 0zm-2.3.786-.154.08-7.438 4.294a1.951 1.951 0 0 0-.97 1.532l-.007.16v8.59c0 .644.317 1.243.841 1.606l.136.086 7.438 4.294c.554.32 1.226.347 1.8.08l.154-.08 7.438-4.294c.558-.322.919-.897.97-1.532l.007-.16v-8.59c0-.644-.317-1.243-.841-1.606l-.136-.086-7.438-4.294a1.953 1.953 0 0 0-1.8-.08zm2.094 6.844v8.974h-2.327v-7.139l2.327-1.835zm3.337-2.026v1.987H13.27v.004h-2.327v-.004H7.608V6.457h9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};
export default SvgMarket;